import React from "react";

function Header() {
  return (
    <header>
      <h2>Шевченко Дмитро В’ячеславович</h2>
    </header>
  );
}

export default Header;
